<aura-edit-wrapper
  title="Adresse professionnelle & Horaires"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-office-hours-form
      [officialAddress]="resolvedOfficialAddress()"
      [officeAddress]="currentAddress()"
      [openingHours]="currentHours()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-office-hours-display
      [profile]="initialProfile()"
      [officeAddress]="currentAddress()"
      [openingHours]="currentHours()"
    />
  }
</aura-edit-wrapper>
